/**
 * Copyright 2018 Phenix Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
define([
    'phenix-web-lodash-light',
    'phenix-web-assert',
    'phenix-web-global',
    'lxiv'
], function(_, assert, global, lxiv) {
    'use strict';

    function StringBuilder() {
        this._tempCharCodes = [];
        this._builtString = '';
    }

    StringBuilder.prototype.push = function push() {
        if ((this._tempCharCodes.length + arguments.length) > 1024) {
            this._builtString += String.fromCharCode.apply(String, this._tempCharCodes);
            this._tempCharCodes.length = 0;
        }

        Array.prototype.push.apply(this._tempCharCodes, arguments);
    };

    StringBuilder.prototype.build = function push() {
        return this._builtString + String.fromCharCode.apply(String, this._tempCharCodes);
    };

    function stringSource(stringValue) {
        var index = 0;

        return function() {
            return index < stringValue.length ? stringValue.charCodeAt(index++) : null;
        };
    }

    return {
        toString: function(byteArray) {
            var begin = 0;
            var end = byteArray.length;
            var stringBuilder = new StringBuilder();

            lxiv.encode(function() {
                return begin < end ? byteArray[begin++] : null;
            }, _.bind(stringBuilder.push, stringBuilder));

            return stringBuilder.build();
        },

        toByteArray: function(data) {
            assert.isString(data, 'data');

            var tempArray = [];

            lxiv.decode(stringSource(data), function(b) {
                tempArray.push(b);
            });

            return new global.Uint8Array(tempArray);
        }
    };
});